import { render } from "./TemplateTen.vue?vue&type=template&id=d8566cfc"
import script from "./TemplateTen.vue?vue&type=script&lang=js"
export * from "./TemplateTen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__